<template>
    <div>
        <h1 class="text-center mt-4 d-none d-lg-block">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de Proveedora de Limpieza de México SA de CV.
        </h1>
        <h4 class="text-center mt-4 d-lg-none">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> Proveedora de Limpieza de México SA de CV.
        </h4>
        <br>
        <div class="alert alert-success text-center" role="alert">
            <p>*Version de pruebas: las facturas en este portal no tendran validez fiscal.</p>
            <b><b-icon icon="heart-fill"></b-icon> ¡Solicita una demo!</b><br>
            Si desea solicitar una demostraci&oacute;n comuniquese al siguiente correo: <b>ventas@sait.com.mx</b>
        </div>
        <div class="card mt-lg-4 mt-2">
            <div class="card-header text-center bg-dark text-white h5">
                <b-icon icon="info-circle"></b-icon>
                Ponemos a su disposici&oacute;n nuestro portal en l&iacute;nea para agilizar el proceso de facturaci&oacute;n
            </div>
            <div class="card-body px-md-5 py-4">
                <p class="card-text">Tome en cuenta los siguientes puntos:</p>
                <ul>
                    <li>Solo se permitir&aacute;n facturar notas de venta emitidos dentro del mismo mes.</li>
                    <li>En caso de requerir cancelaci&oacute;n de su factura, favor de comunicarse con el depto. de
                        contabilidad.
                    </li>
                </ul>
                <div class="text-center">
                    <router-link tag="a" :to="{ name: 'Invoice' }" class="btn btn-lg btn-custom">
                        <b>Facturar</b>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartDemo',
    }
    
</script>

